import React, { useEffect } from 'react';
import {useLocation,useNavigate } from 'react-router-dom';
import {MdOutlineSpaceDashboard,MdOutlineLeaderboard,MdPayment} from 'react-icons/md';
import { useSelector } from 'react-redux';
import {TbMoneybag} from 'react-icons/tb';
import {TfiDashboard} from 'react-icons/tfi';
import { VscGraphLine } from 'react-icons/vsc';
import {SiGoogleadsense} from 'react-icons/si';



function DashboardMenu() {

  const {pathname} = useLocation();
  const path = pathname.split('/')[2]
  const user = useSelector(state=>state.Auth)

  const navigate = useNavigate();

  useEffect(()=>{
    if(path === undefined){
      navigate('/dashboard/my_dashboard')
    }
  },[])


  const menu = [
    {name:'My Dashboard',icon:MdOutlineSpaceDashboard,path:'/dashboard/my_dashboard',id:1,color:'',roles:[]},
  ]  
  const menu1 = [
  {name:'Case List',icon:SiGoogleadsense,path:'/dashboard/case_list',id:1,color:'',roles:['admin','Admin']},
  ]  

  

  return (
    <div className='md:mr-0 md:min-h-screen md:max-h-sceen md:border-r  md:min-w-44 md:max-w-44 md:w-44 px-2' >

        <div className='mb-4 mt-4'>
        <h6 className='mb-2 font-[700] text-[12px]'>Our Dashboard</h6>
       
        <div className='flex  md:block w-auto'>
            {menu.map((m)=>(
               <React.Fragment key={m?.path}>
                <div key={m?.path} className={`flex items-center w-max md:w-[100%] my-1 hover:bg-[#f4f5f7] px-1.5 py-1 ml-2 rounded-md relative cursor-pointer ${pathname ===  m.path && 'bg-[#f4f5f7]'}`} onClick={()=>navigate(m?.path)}>
                  {pathname ===  m.path &&  <span className='border-slate-800 border-2 h-6 rounded absolute -ml-3' ></span>}
                  <m.icon color='#000' style={{backgroundColor:m?.color,padding:'2px'}} size={16}  />
                  <span className='text-[#000] font-[400] ml-2 text-[12px]'>{m.name}</span>
              </div>
              </React.Fragment> 
            ))}
        </div>    
        </div>

       
        <div className='mb-4 mt-4 border-t pt-4'>
        <h6 className='mb-2 font-[700] text-[12px]'>Case Option</h6>
       
        <div className='flex  md:block w-auto'>
            {menu1.map((m)=>(
               <React.Fragment key={m?.path}>
                <div key={m?.path} className={`flex items-center w-max md:w-[100%] my-1 hover:bg-[#f4f5f7] px-1.5 py-1 ml-2 rounded-md relative cursor-pointer ${pathname ===  m.path && 'bg-[#f4f5f7]'}`} onClick={()=>navigate(m?.path)}>
                  {pathname ===  m.path &&  <span className='border-slate-800 border-2 h-6 rounded absolute -ml-3' ></span>}
                  <m.icon color='#000' style={{backgroundColor:m?.color,padding:'2px'}} size={16}  />
                  <span className='text-[#000] font-[400] ml-2 text-[12px]'>{m.name}</span>
              </div>
              </React.Fragment> 
            ))}
        </div>    
        </div>

    </div>
  )
}

export default DashboardMenu